module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": "0.2rem 0.2rem 1rem 0.2rem",
      "height": "100%",
      "text-align": "center"
    }
  }, [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ClubIndex2',
        query: {}
      }),
      expression: "{name:'ClubIndex2',query:{}}"
    }],
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/4c25394f002be36144d87ff7f8201216.png"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'QcxjIndex2',
        query: {}
      }),
      expression: "{name:'QcxjIndex2',query:{}}"
    }],
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/18fd0f829935a046bf9dbea5cee73d2e.png"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2541934d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/QcxjClubIndex.vue
// module id = 2261
// module chunks = 0